module.exports = __webpack_public_path__ + "static/img/shadow.56e0049d.png";